/*
General file for data validation
*/
import { generateSets } from "./ProbabilityTable";



const error_msgs = {
    "prob":
        {
            1: "Value must be a number.",
            2: "Value must be between 0 and 1.",
            3: "Each row must sum to 1."
        },
    "label":
        {
            1: "State and node labels must be between 1 and 40 characters.",
            2: "State and node labels cannot contain tabs or newlines."
        }
}

//NB this validates nodes with extra field condProbVals 
export function validateNode(nodeData) {    
    let labelErs = validateLabel(nodeData.label);
    let stateLabels = nodeData.states.map(state => Object.keys(state)[0]);
    let stateLabelErs = stateLabels.map(label => validateLabel(label));
    stateLabelErs = stateLabelErs.flat();
    let probErs = validateCondProb(nodeData.condProbVals, nodeData.states.length);

    //Get error messages
    let labelMsgs = labelErs.map(err => error_msgs["label"][err]);
    let stateLabelMsgs = stateLabelErs.map(err => error_msgs["label"][err]);
    let probMsgs = probErs.map(err => error_msgs["prob"][err]);

    //Combine error messages and remove duplicates
    let msgs = labelMsgs.concat(stateLabelMsgs, probMsgs);
    msgs = [...new Set(msgs)];

    return msgs;
}

/*Probabilities
Input: 
    1D array of conditional probabilities
    Number of rows in the table
Requirements:
    Values must be numbers (error 1)
    Values must be between 0 and 1 (error 2)
    Values must sum to 1 for each parent combination (error 3)
*/
function validateCondProb(vals, numRows) {
    let errors = [];
    for (let i = 0; i < vals.length; i++) {
        let v = vals[i];
        //Check if value is a number
        if (isNaN(v)) {
            errors.push(1);
            continue;
        }
        
        v = parseFloat(v);
        vals[i] = v;
        

        //Check if value is between 0 and 1
        if (v < 0 || v > 1) { 
            errors.push(2);
        }
    };

        
    //Sorts into their columns
    let sets = generateSets(vals, numRows);
    // Threshold for rounding errors
    let equalityThreshold = 1e-10;
    for (let i = 0; i < sets.length; i++) {
        let set = sets[i];
        //Does set contain a string?
        if (set.some(isNaN)) {
            continue;
        }
        let sum = set.reduce((acc, val) => acc + val, 0);
        if ((Math.abs(sum - 1) > equalityThreshold)) {
            errors.push(3);
        }
    }

    return errors;
}

/*Labels and States
Input: Name as a string
Requirements:
    1 - 40 characters (error 1)
    No tabs or newlines  (error 2)
*/
function validateLabel(name) {
    let errors = [];
    let length = name.length;
    if (length === 0 || length > 40) {
        errors.push(1);
    }
    
    //No tabs or newlines
    if (name.includes("\t") || name.includes("\r") || name.includes("\n")) {
        errors.push(2);
    }

    return errors;
}